import { render, staticRenderFns } from "./WhyBnoxTable.vue?vue&type=template&id=d4bfe5f0&scoped=true"
import script from "./WhyBnoxTable.vue?vue&type=script&lang=js"
export * from "./WhyBnoxTable.vue?vue&type=script&lang=js"
import style0 from "./WhyBnoxTable.vue?vue&type=style&index=0&id=d4bfe5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bfe5f0",
  null
  
)

export default component.exports